import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-db36d71e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "insights-section" }
const _hoisted_2 = {
  key: 0,
  class: "insights-header insights-section-card mb-3 py-2 px-2"
}
const _hoisted_3 = { class: "score-chart mb-1" }
const _hoisted_4 = {
  key: 0,
  class: "text-primary font-weight-normal mb-0"
}
const _hoisted_5 = { class: "lead text-center mb-2" }
const _hoisted_6 = { class: "text-center mb-2" }
const _hoisted_7 = { class: "insights-section-card insights-content py-2" }
const _hoisted_8 = { class: "insights-overview" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-primary font-weight-normal mb-0" }
const _hoisted_11 = { class: "d-flex align-items-center justify-content-center p-1" }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "legend bg-success" }, null, -1))
const _hoisted_14 = { class: "product-wrapper justify-content-center justify-content-lg-start text-center text-lg-left" }
const _hoisted_15 = { class: "pr-2" }
const _hoisted_16 = { class: "lead text-primary font-weight-normal mb-0" }
const _hoisted_17 = { class: "text-grey mb-0" }
const _hoisted_18 = { class: "d-flex flex-row w-100" }
const _hoisted_19 = { class: "product-icon-wrapper mr-1" }
const _hoisted_20 = ["alt", "title"]
const _hoisted_21 = { class: "product-usage-wrapper" }
const _hoisted_22 = { class: "product-usage-details" }
const _hoisted_23 = { class: "usage-details-bar" }
const _hoisted_24 = { class: "usage-details-value" }
const _hoisted_25 = { class: "product-icon-wrapper mr-1" }
const _hoisted_26 = { class: "product-usage-wrapper" }
const _hoisted_27 = { class: "pr-2" }
const _hoisted_28 = { class: "text-primary font-weight-normal mb-0" }
const _hoisted_29 = { class: "text-grey mb-0" }
const _hoisted_30 = { class: "product-usage-details" }
const _hoisted_31 = { class: "usage-details-bar" }
const _hoisted_32 = { class: "usage-details-value" }
const _hoisted_33 = { class: "text center px-2 pb-2" }
const _hoisted_34 = { class: "mb-0 mt-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chart = _resolveComponent("Chart")!
  const _component_Button = _resolveComponent("Button")!
  const _component_AdvisorInsightSkeleton = _resolveComponent("AdvisorInsightSkeleton")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_ScrollPanel = _resolveComponent("ScrollPanel")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (!_ctx.isSpinnerVisible('advice') && !_ctx.showNoInsightMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Chart, {
              data: _ctx.scoreChartData,
              options: _ctx.scoreChartOptions,
              type: "doughnut"
            }, null, 8, ["data", "options"])
          ]),
          (_ctx.score)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(_ctx.$t("myCadac.advisorInsights.scoreTitle")), 1))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("myCadac.advisorInsights.title", { months: 12 })), 1),
          _createElementVNode("small", _hoisted_6, _toDisplayString(_ctx.$t("myCadac.advisorInsights.contactMessage")), 1),
          (_ctx.layoutStore.chatWidgetAvailable)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                class: "p-button-success p-button-sm",
                label: _ctx.$t('digitalAdvisor.button.contactUs'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.initChat(`${_ctx.$t('myCadac.advisorAdvice.chatMessage.contactSupport')}`)))
              }, null, 8, ["label"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isSpinnerVisible('advice') && _ctx.hasInsightProductsToShow)
      ? (_openBlock(), _createBlock(_component_BlockUI, {
          key: 1,
          "auto-z-index": "",
          blocked: _ctx.advisorStore.isAccessRestricted,
          class: "blurred-content"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              (_ctx.isSpinnerVisible('advice'))
                ? (_openBlock(), _createBlock(_component_AdvisorInsightSkeleton, { key: 0 }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("h4", _hoisted_10, _toDisplayString(_ctx.$t("myCadac.advisorInsights.usageAnalysis")), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("myCadac.advisorInsights.usageLabel")), 1)
                  ])
                ]),
                _createVNode(_component_Divider),
                _createVNode(_component_ScrollPanel, {
                  class: "px-1 custom-scroll-bar",
                  style: {"width":"100%","height":"clamp(450px, 35vh, 1000px)"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Accordion, {
                      "active-index": _ctx.productAccordionActiveIndexes,
                      class: "accordion-products",
                      multiple: true
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.insightProductsToShow, (product) => {
                          return (_openBlock(), _createBlock(_component_AccordionTab, {
                            key: `${product.name}`
                          }, {
                            header: _withCtx(() => [
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, [
                                  _createElementVNode("span", _hoisted_16, [
                                    _createTextVNode(_toDisplayString(product.name) + " - ", 1),
                                    _createElementVNode("small", _hoisted_17, [
                                      _createTextVNode("Seats: "),
                                      _createElementVNode("b", null, _toDisplayString(product.statistics.seats), 1)
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_18, [
                                  _createElementVNode("div", _hoisted_19, [
                                    _withDirectives(_createElementVNode("img", {
                                      alt: product.iconAlt,
                                      class: "product-icon",
                                      title: product.name
                                    }, null, 8, _hoisted_20), [
                                      [_directive_lazy, product.iconUrl]
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_21, [
                                    _createElementVNode("div", _hoisted_22, [
                                      _createElementVNode("div", _hoisted_23, [
                                        _createElementVNode("div", {
                                          class: "usage-details-fill",
                                          style: _normalizeStyle({ width: `${_ctx.usagePercent(product.statistics)}%` })
                                        }, null, 4)
                                      ]),
                                      _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.usagePercent(product.statistics)) + "%", 1)
                                    ])
                                  ])
                                ])
                              ])
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.licenses, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: `${product.name}_item${index}`,
                                  class: "product-wrapper product-licences justify-content-center justify-content-lg-start text-center text-lg-left"
                                }, [
                                  _createElementVNode("div", _hoisted_25, [
                                    _createVNode(_component_font_awesome_icon, {
                                      class: "product-item-icon",
                                      icon: _ctx.productItemTypeIcon(item.licenseType),
                                      size: "1x"
                                    }, null, 8, ["icon"])
                                  ]),
                                  _createElementVNode("div", _hoisted_26, [
                                    _createElementVNode("div", _hoisted_27, [
                                      _createElementVNode("span", _hoisted_28, [
                                        _createTextVNode(_toDisplayString(_ctx.productItemTypeLabel(item.licenseType)) + " - ", 1),
                                        _createElementVNode("small", _hoisted_29, [
                                          _createTextVNode("Seats: "),
                                          _createElementVNode("b", null, _toDisplayString(item.usage?.seats), 1)
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_30, [
                                      _createElementVNode("div", _hoisted_31, [
                                        _createElementVNode("div", {
                                          class: "usage-details-fill",
                                          style: _normalizeStyle({ width: `${_ctx.usagePercent(item.usage)}%` })
                                        }, null, 4)
                                      ]),
                                      _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.usagePercent(item.usage)) + "%", 1)
                                    ])
                                  ])
                                ]))
                              }), 128)),
                              _createVNode(_component_Divider)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128)),
                        _createVNode(_component_Divider)
                      ]),
                      _: 1
                    }, 8, ["active-index"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Divider),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.$t("myCadac.advisorInsights.totalUsageDisclaimer")), 1)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["blocked"]))
      : _createCommentVNode("", true)
  ]))
}